import React from 'react';

import { Button, PageTitle } from '@atoms';
import { PageHeader } from '@molecules';
import { Table } from '@organisms';

const RecordTable = ({
  title,
  createNewTitle,
  onCreateNew,
  isFetching,
  dataSource,
  rowKey,
  header,
  columns,
  pagination,
  ariaLabel = 'Create new',
  showHeader,
  className,
  extra = [],
}) => {
  return (
    <>
      <PageHeader
        title={<PageTitle style={{ whiteSpace: 'pre-wrap' }}>{title}</PageTitle>}
        extra={
          createNewTitle && [
            // TODO: move aria-label to props
            <Button type="primary" aria-label={ariaLabel} key={1} onClick={onCreateNew} style={{ minWidth: 200 }}>
              {createNewTitle}
            </Button>,
            ...extra,
          ]
        }
      />
      <Table
        isFetching={isFetching}
        dataSource={dataSource}
        rowKey={rowKey}
        header={header}
        columns={columns}
        pagination={pagination}
        showHeader={showHeader}
        className={className}
      />
    </>
  );
};

export default RecordTable;
